// src/components/Layout/UnifiedPageWrapper.js

import React from "react";
import { Box, Paper, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useLandscape from "../../hooks/useLandscape";


// ⭐ New modern clean header
import PageHeaderCard from "../PageHeader";



const UnifiedPageWrapper = ({ title, subtitle, children, actionButton }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:768px)");
  const isLandscape = useLandscape();

  return (
    <Box
      sx={{
        p: { xs: isLandscape ? 0.5 : 1, md: 4 },
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        bgcolor: "background.default",
        color: "text.primary",
        minHeight: "auto",

        overflow: "visible",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: { xs: isLandscape ? 1.5 : 1, md: 6 },
          width: "100%",
          maxWidth: {
            xs: "100%",
            sm: "100%",
            md: "1200px",
            lg: "1400px",
            xl: "1600px",
          },
          margin: "0 auto",
          minHeight: isLandscape ? "auto" : "80vh",
          borderRadius: 3,
          bgcolor: "background.paper",
          boxShadow: (theme) =>
            theme.palette.mode === "dark"
              ? "0px 2px 8px rgba(0,0,0,0.3)"
              : "0px 2px 8px rgba(0,0,0,0.05)",
          display: "flex",
          flexDirection: "column",
          border: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        {title && (
          <PageHeaderCard
            title={title}
            subtitle={subtitle}
            actions={actionButton}
          />
        )}

        {/* ---------------------------- CONTENT ---------------------------- */}
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "visible",
            overflowX: "hidden",
            p: 0,
            m: 0,
            minHeight: 0, // allow SmartTable to scroll
          }}
        >
          {children}
        </Box>
      </Paper>
    </Box>
  );
};

export default UnifiedPageWrapper;
